<template>
    <nav aria-label="breadcrumb" style="background-color: #1E6E53; margin-left: 0.5%; margin-right: 0.5%; margin-top: 1%">
        <ol class="breadcrumb  " style="background-color: #1E6E53">
            <li class="breadcrumb-item" style="color: #fff"><span style="">  <span v-if="account.etat">Matricule</span><span v-else>Livret</span> : {{account.matricule}} > </span><a href="#">Tableau de bord</a></li>
            <li class="breadcrumb-item active" style="color: #E9E3E3" aria-current="page">{{page}} </li>
        </ol>
    </nav>
</template>

<script>
    export default {
        name: "Breadcrumb",
        props: ['page'],
        computed: {
            user() {
                return this.$store.getters['auth/loggedAs'];
            },
            account(){
                return JSON.parse(localStorage.getItem("gesproAccount")) || {};
            },
        },
    }
</script>

<style scoped>

</style>